import Dexie, { type EntityTable } from "dexie";

/* クルー用ローカルDB */
const crewDb = new Dexie("CrewDatabase") as Dexie & {
  reportPhotos: EntityTable<CrewReports, "id">;
};

crewDb.version(1).stores({
  reportPhotos: "++id,taskId,photoId,lastModified"
});

type CrewReports = {
  id: number; //IndexDBのid
  taskId: number;
  photoId: number;
  lastModified: number;
};

export { crewDb, type CrewReports };
